import { journeyAction, } from './base';

import { JourneyActionStartMailInbound as JourneyActionStartMailBase, } from 'atlas-shared';

export const JourneyActionStartMailInbound = journeyAction({
  ...JourneyActionStartMailBase,
  icon: 'Mail',
});
